// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ProximityArea } from './proximity-area';
import { ProximityRoleRightMap } from './proximity-role-right-map';
import { ProximityAreaEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProximityRole extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId?: string;
  /** Enum FK area */
  areaId!: ProximityAreaEnum;
  /** String(250) */
  description?: string;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** FK accountId */
  account!: Account;
  /** FK areaId */
  area!: ProximityArea;
  /** Inv FK proximityRoleId */
  proximityRoleRightMaps!: ProximityRoleRightMap[];
}

